/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Store_4Inputs */

const en_bot_store_4 = /** @type {(inputs: Bot_Store_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raw HTML is not stored. Masked text is only sent to the AI model provider Bystep uses for that analysis, and is never sold.`)
};

const id_bot_store_4 = /** @type {(inputs: Bot_Store_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML mentah tidak disimpan. Teks yang sudah disamarkan hanya dikirim ke penyedia model AI yang dipakai Bystep untuk analisis itu, dan tidak pernah dijual.`)
};

/**
* | output |
* | --- |
* | "Raw HTML is not stored. Masked text is only sent to the AI model provider Bystep uses for that analysis, and is never sold." |
*
* @param {Bot_Store_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_store_4 = /** @type {((inputs?: Bot_Store_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Store_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_store_4(inputs)
	return en_bot_store_4(inputs)
});